import { SlackChannel } from '@mode/shared/contract-common';
import { RawScheduleOwner, SlackApp } from './schedule-owner.contract';

export interface RawSlackMembership {
  channelName: string;
  channel: string;
  channel_id: string;
  channel_type: 'public' | 'private';
}

export abstract class ScheduleSlackFacade {
  public abstract slackAppUrl: string;
  public abstract slackAppTeamName: string;
  public abstract slackChannels: Array<SlackChannel> | [];

  protected abstract _ModeCollection: any;
  protected abstract _rawScheduleOwner: RawScheduleOwner;

  public abstract initialize(rawScheduleOwner: RawScheduleOwner, ModeCollection: any): void;

  public abstract getSlackChannel(membership: RawSlackMembership): SlackChannel;

  public abstract tryToInitialize(): Promise<boolean>;

  protected abstract getSlackApp(): Promise<SlackApp>;

  protected abstract get hasSlackApp(): boolean;
}
